const activityList = [
  "5月22日开幕式",
  "5月23日博士后座谈会及平台授牌仪式",
  "5月24日人才沙龙及人才培训活动",
  "5月25日青年人才联谊会",
  "5月26日“来腾飞的地方”专项人才招聘活动",
];
export default activityList;
